var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DisplayField from "@/components/fields/displayField";
import { useGetModuleFieldDefsQuery, useGetModuleFieldsQuery, } from "@/store/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsLeft } from "@fortawesome/pro-regular-svg-icons";
import { getDetailAddress } from "@/components/fields/address/detail";
export var Merge = function (_a) {
    var records = _a.records, module = _a.module, viewType = _a.viewType, isSecondary = _a.isSecondary, fieldIsUpdated = _a.fieldIsUpdated;
    // Get field_defs
    var listFields = useGetModuleFieldsQuery(module || "").data;
    var field_defs = (listFields && (listFields === null || listFields === void 0 ? void 0 : listFields.data.attributes)) || [];
    // studio field
    var studioFields = useGetModuleFieldDefsQuery(module || "Accounts").data;
    var studio_fields = (studioFields && studioFields.data.layout) || [];
    useEffect(function () {
        setFields(studio_fields === null || studio_fields === void 0 ? void 0 : studio_fields.map(function (item) {
            return item.name;
        }));
    }, [studio_fields]);
    var _b = useState([]), fields = _b[0], setFields = _b[1];
    var t = useTranslation(["common", module || ""]).t;
    var fieldUpdated = function (field) {
        fieldIsUpdated && fieldIsUpdated(field);
    };
    var _c = useState(false), isAddress = _c[0], setIsAddress = _c[1];
    return (_jsx("div", { children: Object.entries(records).map(function (item, key) {
            var _a;
            var fieldName = item[0];
            var fieldDef = field_defs[fieldName] ? field_defs[fieldName] : {};
            var fieldLabel = ((_a = field_defs[fieldName]) === null || _a === void 0 ? void 0 : _a.vname)
                ? t(field_defs[fieldName].vname, { ns: module })
                : "";
            return (_jsx("div", __assign({ className: "mr-6" }, { children: fields !== undefined &&
                    fields.includes(fieldName) &&
                    fieldName &&
                    fieldName !== "id" &&
                    fieldDef.source !== "non-db" && (_jsxs("div", __assign({ className: isSecondary ? "flex flex-row pb-1 pt-2" : "" }, { children: [_jsx("div", __assign({ className: "flex bg-gray-100 justify-center px-2 rounded-full" }, { children: isSecondary && (_jsx("button", __assign({ className: "button primary outlined", id: fieldName, onClick: function (f) {
                                    var _a;
                                    var _b;
                                    var name = (_b = document.getElementById("".concat(fieldName))) === null || _b === void 0 ? void 0 : _b.id;
                                    // Champ de type addresse
                                    if (fieldDef &&
                                        fieldDef.type === "varchar" &&
                                        fieldDef.group &&
                                        isSecondary &&
                                        fieldDef.group !== "email1") {
                                        var addressValue_1 = getDetailAddress(fieldDef.group, records, field_defs);
                                        setIsAddress(true);
                                        var addressFields = [
                                            "street",
                                            "city",
                                            "state",
                                            "postalcode",
                                            "country",
                                        ];
                                        var addressFieldKeys_1 = addressFields.map(function (field) { return "".concat(fieldDef.group, "_").concat(field); });
                                        var updatedFields = Object.fromEntries(addressFields.map(function (field, index) { return [
                                            addressFieldKeys_1[index],
                                            addressValue_1[field],
                                        ]; }));
                                        fieldUpdated(updatedFields);
                                    }
                                    else {
                                        fieldUpdated((_a = {}, _a[name] = records[name], _a));
                                    }
                                } }, { children: _jsx(FontAwesomeIcon, { icon: faChevronsLeft }) }))) })), _jsx("div", __assign({ className: isSecondary ? "ml-4" : "" }, { children: _jsx(DisplayField, { record: records, moduleName: module, fieldName: fieldName, viewType: viewType, fieldLabel: fieldLabel, fieldMetadata: fieldDef, hideLabel: false, className: "p-1", labelClassName: "font-medium", onUpdate: fieldUpdated, isEditable: false, fieldDef: isAddress ? field_defs : {} }) }))] }))) }), key));
        }) }));
};
